import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { stripRem } from '../../utils/size-manipulation.js';
import 'react';
import { useTheme } from '../../utils/hooks/use-theme.js';
import { StyledSvg } from './icon.style.js';
import paths from './paths.js';
import snakeCase from '../../node_modules/lodash-es/snakeCase.js';
import randomKey from '../../node_modules/warbler/dist/number/random-key.js';

const Icon = props => {
    const { className = '', icon, margin, opacity = 'high', scale = 2, title, path, color = 'primary' } = props, rest = __rest(props, ["className", "icon", "margin", "opacity", "scale", "title", "path", "color"]);
    const theme = useTheme();
    const titleId = `${snakeCase(title)}-${randomKey()}`;
    const iconSize = stripRem(theme.iconSizes.step) * scale;
    const minimumScale = stripRem(theme.iconSizes.minimum) / stripRem(theme.iconSizes.step);
    // TODO: Once this is in typescript, we can use a Union type to ensure
    // that one of these two are present
    if (!path && !icon) {
        // eslint-disable-next-line no-console
        console.warn('Must specify a path or an icon');
    }
    if (scale < minimumScale) {
        // eslint-disable-next-line no-console
        console.warn(`The scale prop must be at least ${minimumScale}`);
    }
    return (jsxs(StyledSvg, Object.assign({ "aria-labelledby": title ? titleId : undefined, className: className, viewBox: "0 0 16 16", margin: margin, iconSize: iconSize, xmlns: "http://www.w3.org/2000/svg", shapeRendering: "auto" }, rest, { children: [title && jsx("title", Object.assign({ id: titleId }, { children: title }), void 0),
            jsx("path", { d: icon ? paths[icon] : path, fill: theme.colors.content[color], fillOpacity: theme.opacities[opacity], fillRule: "evenodd", color: color, "data-testid": "icon-path" }, void 0)] }), void 0));
};

export { Icon };
